export function getGreaterDate(d1?: Date|null, d2?: Date|null): Date | undefined {
    if (d1 && d2)
        return d1 > d2 ? d1 : d2;
    else if (d1)
        return d1;
    else
        return d2 ?? undefined;
}
